const sectionReviewGridSection03Css = `
[data-type='section-review-grid-section-03'] .wrapper-container[data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-review-grid-section-03'] .wrapper-container[data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-review-grid-section-03'] .wrap-items {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

[data-type='section-review-grid-section-03'] .wrap-items .item-reivew {
  border-radius: 20px;
  padding: 14px 16px;
  width: calc((100% - 16px) / 2);
}

[data-type='section-review-grid-section-03'] .wrap-items .item-reivew:nth-child(3n + 1) {
  width: 100%;
}

[data-type='section-review-grid-section-03'] .wrap-items .item-reivew .user-name {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}

[data-type='section-review-grid-section-03'] .wrap-items .item-reivew .user-name .wrap-verified {
  display: flex;
  align-items: center;
  gap: 5px;
}

[data-type='section-review-grid-section-03'] .wrap-items .item-reivew .user-name .wrap-verified svg {
  display: block;
}

[data-type='section-review-grid-section-03'] .wrap-items .item-reivew .user-name .wrap-verified .verified {
  font-size: 12px;
  border-radius: 100px;
  border: 1px solid;
  padding: 2px 8px;
  line-height: normal;
}

[data-type='section-review-grid-section-03'] .wrap-items .item-reivew .wrap-stars {
  color: #ffd700;
  margin-bottom: 5px;
}

[data-type='section-review-grid-section-03'] .wrap-items .item-reivew .wrap-stars svg {
  fill: #ffd700;
}

[data-type='section-review-grid-section-03'] .wrap-items .item-reivew .title-review {
  font-weight: bold;
  font-size: 17px;
  margin-bottom: 5px;
}

@container (max-width: 768px) {
  [data-type='section-review-grid-section-03'] .wrapper-container[data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-review-grid-section-03'] .wrapper-container[data-bottom-padding='true'] {
    padding-bottom: 16px;
  }
}

@container (max-width: 640px) {
  [data-type='section-review-grid-section-03'] .wrap-items .item-reivew {
    width: 100%;
  }
}
`;
export default sectionReviewGridSection03Css;
